import styled from 'styled-components';

export const CustomTitle = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
`;

export const TableWrapper = styled.div`
	border-radius: ${({ theme }) => theme.border.border_radius.br_xl};
	overflow: hidden;
	border: 1px solid ${({ theme }) => theme.palette.secondary.white};
	width: 100%;
	background-color: ${({ theme }) => theme.palette.secondary.white};
	display: flex;
	flex-direction: column;
`;

export const RiskLevel = styled.div`
	width: 127px;
	height: 32px;
	padding: 8px;
	border-radius: 4px;
	text-align: center;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
`;

export const CustomTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	align-items: center;
	justify-content: center;
	margin: 0 auto;

	tr {
		border-top: 2px solid ${({ theme }) => theme.palette.secondary.white} !important;
	}

	th,
	td {
		padding: 10px 15px;
	}
	td {
		font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
		font-weight: ${({ theme }) => theme.sizes.weights.regular};
	}

	thead {
		background-color: ${({ theme }) => theme.palette.secondary[100]};

		th {
			color: ${({ theme }) => theme.colors.text};
			font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
			font-weight: ${({ theme }) => theme.sizes.weights.semibold};
			border-left: 1px solid ${({ theme }) => theme.palette.secondary.white};
			border-right: 1px solid ${({ theme }) => theme.palette.secondary.white};
			border-top: 1px solid ${({ theme }) => theme.palette.secondary.white};
			border-bottom: none;
		}

		th:first-child {
			border-left: none;
		}

		th:last-child {
			border-right: none;
		}

		&:first-child {
			tr {
				&:first-child {
					border-top: none !important;
				}
			}
		}
	}

	tbody {
		background-color: ${({ theme }) => theme.palette.secondary[50]};
	}
`;
